import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function HomeSearchBar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  return (
    <div className="mx-auto -mt-10 w-full max-w-[1200px] px-4 md:-mt-12 md:px-8">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 sm:flex-row sm:items-center sm:gap-2 sm:rounded-full sm:p-2"
      >
        <div className="flex flex-1 items-center gap-2 rounded-md px-3 py-1.5 sm:rounded-full">
          <i className="ri-search-2-line text-lg text-primary-500" />
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="输入影视名称或标签，如「月影妖精」「治愈」"
            className="w-full bg-transparent py-1 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
        </div>
        <button
          type="submit"
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:rounded-full"
        >
          搜索妖精影视
        </button>
      </form>
    </div>
  );
}